import React, { createElement, FunctionComponent, ReactNode } from 'react';
import { createRoot } from 'react-dom/client';
import { extractDataFromElement } from './data';

const render = <T>(querySelector: string, Component: FunctionComponent<T>, dataProps?: boolean) => {
  const elementList = document.querySelectorAll(querySelector);
  elementList.forEach((elem) => {
    const props = dataProps ? extractDataFromElement<T>(elem, 'data-props') : undefined;
    if (props || !dataProps) {
      const root = createRoot(elem);
      root.render(
        createElement(
          Component as FunctionComponent<{}>,
          props as React.Attributes,
          elem.childNodes as ReactNode
        )
      );
    }
  });
};

export default render;
